var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGoogleLogoAlt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#fff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#googleLogoAlt_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.68 16.182c0-.567-.05-1.113-.145-1.636H16v3.094h4.305a3.68 3.68 0 0 1-1.596 2.415v2.007h2.586c1.512-1.393 2.385-3.444 2.385-5.88Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 24c2.16 0 3.971-.716 5.295-1.938l-2.586-2.008c-.716.48-1.633.764-2.709.764-2.084 0-3.847-1.407-4.476-3.298H8.85v2.073A7.997 7.997 0 0 0 16 24Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.524 17.52c-.16-.48-.251-.993-.251-1.52s.09-1.04.25-1.52v-2.073H8.852A7.996 7.996 0 0 0 8 16c0 1.29.31 2.513.85 3.593l2.674-2.073Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 11.182c1.175 0 2.23.403 3.058 1.196l2.295-2.294C19.967 8.793 18.156 8 16 8a7.997 7.997 0 0 0-7.15 4.407l2.674 2.073c.629-1.89 2.392-3.298 4.476-3.298Z",
  fill: "#EA4335"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "googleLogoAlt_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(8 8)",
  d: "M0 0h16v16H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleLogoAlt);
export default ForwardRef;